/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  APPLICATION_VIEW_CORPORATE,
  APPLICATION_VIEW_MASTER,
  EMAIL_TEMPLATE_INTERNAL_TYPE,
  EMAIL_TEMPLATE_JOB_TYPE,
  EMAIL_TEMPLATE_LAYOUT_TYPE,
  EMAIL_TEMPLATE_SYSTEM_TYPE,
} from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { EmailTemplateDetailsComponent } from './components/email-template-details/email-template-details.component';
import { EmailTemplateListTabComponent } from './components/email-template-list-tab/email-template-list-tab.component';
import { EmailTemplatesTabContainerComponent } from './components/email-template-tab-container/email-template-tab-container.component';
import { EmailTemplateDetailsBusinessService } from './resources/email-template-details-business.service';
import { EmailTemplateTabBusinessService } from './resources/email-template-tab-business.service';

const routes = [
  createRoute({
    component: EmailTemplateDetailsComponent,
    path: 'templates/new',
    pathMatch: 'full',
    leave: true,
    init: EmailTemplateDetailsBusinessService,
    auth: {
      permission: 'Setup.Templates.Job.CREATE',
    },
  }),
  createRoute({
    component: EmailTemplateDetailsComponent,
    path: 'templates/:templateId',
    pathMatch: 'full',
    init: EmailTemplateDetailsBusinessService,
    leave: true,
    auth: {
      permission: [
        'Setup.Templates.System.EDIT',
        'Setup.Templates.System.VIEW',
        'Setup.Templates.Job.EDIT',
        'Setup.Templates.Job.VIEW',
        'Setup.Templates.Internal.EDIT',
        'Setup.Templates.Layout.EDIT',
      ],
    },
  }),
  createRoute({
    component: EmailTemplatesTabContainerComponent,
    path: '',
    children: [
      createRoute({
        component: EmailTemplateListTabComponent,
        init: EmailTemplateTabBusinessService,
        path: 'templates_system',
        static: {
          type: EMAIL_TEMPLATE_SYSTEM_TYPE,
        },
        auth: {
          permission: 'Setup.Templates.System.LIST',
        },
      }),
      createRoute({
        component: EmailTemplateListTabComponent,
        path: 'templates_job',
        init: EmailTemplateTabBusinessService,
        static: {
          type: EMAIL_TEMPLATE_JOB_TYPE,
        },
        auth: {
          permission: 'Setup.Templates.Job.LIST',
        },
      }),
      createRoute({
        component: EmailTemplateListTabComponent,
        path: 'templates_internal',
        init: EmailTemplateTabBusinessService,
        static: {
          type: EMAIL_TEMPLATE_INTERNAL_TYPE,
        },
        auth: {
          applicationView: APPLICATION_VIEW_CORPORATE,
        },
      }),
      createRoute({
        component: EmailTemplateListTabComponent,
        path: 'templates_layout',
        init: EmailTemplateTabBusinessService,
        static: {
          type: EMAIL_TEMPLATE_LAYOUT_TYPE,
        },
        auth: {
          applicationView: [APPLICATION_VIEW_CORPORATE, APPLICATION_VIEW_MASTER],
        },
      }),
    ],
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupEmailTemplatesRoutingModule {
}
